// ============================================
// 🚀 PROJETS
// Ajoute ou modifie tes projets ici
// ============================================

export const projects = [
  {
    title: "Réseau Social Web & Mobile",
    description: "Application complète de réseau social avec version web et mobile. Fonctionnalités de posts, commentaires, likes et messagerie.",
    technologies: ["PHP", "Vue.js", "Flutter"],
    color: "#00D9FF",
    // Optionnel: ajoute ces champs si tu veux des liens
    // github: "https://github.com/...",
    // demo: "https://...",
    // image: "/images/projet1.png"
  },
  {
    title: "Gestion de Stock Cuisine",
    description: "Application web de gestion d'inventaire pour cuisine professionnelle. Suivi des stocks, alertes et rapports.",
    technologies: ["PHP Laravel", "React"],
    color: "#FF6B6B"
  },
  {
    title: "Projets API Laravel",
    description: "Plusieurs projets utilisant des API RESTful Laravel. Authentification, CRUD complet et documentation.",
    technologies: ["Laravel", "API REST", "SQL"],
    color: "#4ECDC4"
  },
  {
    title: "Projet Docker",
    description: "Configuration et déploiement d'environnements de développement avec Docker et Docker Compose.",
    technologies: ["Docker", "Docker Compose", "Linux"],
    color: "#9B59B6"
  },
  {
    title: "Jeu du Pendu",
    description: "Jeu classique du pendu avec système de score.",
    technologies: ["Python"],
    color: "#F39C12"
  }
];
